module.exports = __webpack_public_path__ + "img/tools.cd0198c3.svg";